import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit';
import {apiRequestPostMemberForm} from "../../api/apiRequests";
import {NavigateFunction} from "react-router-dom";
import {checkRedirect} from "../login/RequireAuth";

export interface MemberFormState {
  calendarDates: number[],
  instagramPage: string,
  marketingGoals: string,
  postFormStatus: string,
}

const initialState: MemberFormState = {
  calendarDates: [],
  instagramPage: "",
  marketingGoals: "",
  postFormStatus: "",
}

export const getDateObjectsFromUnix = (dates: number[]) => {
  return dates.map(number => new Date(number));
}

export const getFilesSize = (files: FileList) => {
  if (!files) {
    return 0
  }
  const total = [].slice.call(files).reduce((totalMb:number, file: File) => {
    return totalMb + file.size / 1024 / 1024
  }, 0)
  return Math.round(total * 100) / 100
}

export const fetchPostForm = createAsyncThunk(
  'memberForm/post',
  async (params: {formData: FormData, navigate: NavigateFunction}) => {
    const {formData} = params;
    // {media: FileList, startPlan: string, endPlan: string, instagramPage?: string, marketingGoals?: string}
    // const response = await get("books.json");
    const response = await apiRequestPostMemberForm(formData);
    await checkRedirect(params, response);
    return typeof response === "object" ? response?.data : [];
  },
)

export const memberFormSlice = createSlice({
  name: 'memberForm',
  initialState,
  reducers: {
    setMemberFormValue: (state, action: PayloadAction<{name: string, value: string}>) => {
      // @ts-ignore
      state[action.payload.name] = action.payload.value;
    },
    setMemberFormCalendar: (state, action: PayloadAction<number[]>) => {
      state.calendarDates = action.payload
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchPostForm.pending, (state) => {
        state.postFormStatus = "loading"
      })
      .addCase(fetchPostForm.fulfilled,
        (
          state,
          // action:PayloadAction<{editedFiles: MemberFile[], processingFiles: MemberFile[]}>
        ) => {
          state.postFormStatus = "succeeded";
        })
      .addCase(fetchPostForm.rejected, (state) => {
        state.postFormStatus = "failed"
      })
  }
});

export const {
  setMemberFormValue,
  setMemberFormCalendar ,
} = memberFormSlice.actions;

export default memberFormSlice.reducer